module.exports = __webpack_public_path__ + "static/img/xm2.694f361.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/xm/xm2.png
// module id = OODP
// module chunks = 0